import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SpinnerService } from './spinner.service';
import { ToastService } from './toast.service';

@Injectable({
  providedIn: 'root'
})
export class AwsService {

  constructor(
    private http: HttpClient,
    public spinnerService: SpinnerService,
    public toastService: ToastService
  ) { }

  /* -------------------------------------------------------------------------- */
  /*                              ANCHOR uploadFile                             */
  /* -------------------------------------------------------------------------- */
  // region uploadFile
  async uploadFile(
    uploadUrl: string,
    file: Blob,
    contentType: string,
    message: string = 'Subiendo archivo...'
  ): Promise<boolean> {

    console.log('uploadUrl', uploadUrl);
    console.log('file', file);

    let flag = false;

    this.spinnerService.loading = true;
    this.spinnerService.message = message;

    try {

      const response = await new Promise<boolean>(
        (resolve, reject) => {
          this.http.put(
            uploadUrl,
            file,
            {
              headers: {
                'Content-Type': contentType
              },
            }
          ).subscribe({
            next: (res) => {

              console.log(res);

              resolve(true);
            },
            error: (error) => {
              console.error(error);
              if (error.error) {
                resolve(false);
              } else {
                this.toastService.show({
                  header: 'Error de servidor',
                  body: `${error}`,
                  classname: 'bg-danger text-white'
                });
                reject(false);
              }
            }
          });
        }
      );

      flag = response;

    } catch (error) {
      console.log(error);
      this.toastService.show({
        header: 'Error',
        body: `${error}`,
        classname: 'bg-danger text-white'
      });
    }

    finally {
      this.spinnerService.loading = false;
      this.spinnerService.message = '';
    }

    return flag;

  }

}
